/*
 * Tabby + Tamara instalment widgets (rb-bnpl).
 * Config comes from snippets/rb-bnpl-head.liquid (window.rbBnpl).
 * Every [data-rb-bnpl] container gets a Tabby promo and a Tamara summary for
 * its data-amount (cents). Containers re-price on the theme's variant-change and
 * cart-update events, and new containers (cart drawer re-renders) are picked up
 * by a MutationObserver.
 */
(function () {
  const cfg = window.rbBnpl;
  if (!cfg || window.rbBnplLoaded) return;
  window.rbBnplLoaded = true;
  if (cfg.currency !== 'AED' && cfg.currency !== 'SAR') return;

  let uid = 0;
  const loaders = {};

  function loadScript(src) {
    if (!loaders[src]) {
      loaders[src] = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return loaders[src];
  }

  if (cfg.tamara) {
    window.tamaraWidgetConfig = {
      lang: cfg.lang,
      country: cfg.tamara.country,
      publicKey: cfg.tamara.publicKey,
      css: ':host { --font-primary: inherit !important; --font-secondary: inherit !important; }',
      style: { fontSize: '14px', badgeRatio: 1.2 },
    };
  }

  const toMajor = (cents) => (Number(cents) / 100).toFixed(2);

  function renderTabby(slot, amount, source) {
    if (!cfg.tabby) return;
    slot.innerHTML = '';
    const target = document.createElement('div');
    target.id = 'RbTabbyPromo-' + ++uid;
    slot.appendChild(target);
    loadScript('https://checkout.tabby.ai/tabby-promo.js')
      .then(() => {
        if (!document.getElementById(target.id) || typeof window.TabbyPromo !== 'function') return;
        new window.TabbyPromo({
          selector: '#' + target.id,
          currency: cfg.currency,
          price: toMajor(amount),
          lang: cfg.lang,
          source: source,
          shouldInheritBg: true,
          publicKey: cfg.tabby.publicKey,
          merchantCode: cfg.tabby.merchantCode,
        });
      })
      .catch(() => {});
  }

  function renderTamara(slot, amount) {
    if (!cfg.tamara) return;
    slot.innerHTML = '';
    const el = document.createElement('tamara-widget');
    el.setAttribute('type', 'tamara-summary');
    el.setAttribute('amount', toMajor(amount));
    el.setAttribute('inline-type', '2');
    el.setAttribute('config', '{"badgePosition":"right","showExtraContent":""}');
    slot.appendChild(el);
    loadScript('https://cdn.tamara.co/widget-v2/tamara-widget.js').catch(() => {});
  }

  function render(container) {
    const amount = Number(container.dataset.amount || 0);
    if (!amount) {
      container.innerHTML = '';
      container.dataset.renderedAmount = '0';
      return;
    }
    if (container.dataset.renderedAmount === String(amount)) return;
    container.dataset.renderedAmount = String(amount);

    let tabby = container.querySelector('.rb-bnpl__tabby');
    let tamara = container.querySelector('.rb-bnpl__tamara');
    if (!tabby) {
      tabby = document.createElement('div');
      tabby.className = 'rb-bnpl__tabby';
      container.appendChild(tabby);
    }
    if (!tamara) {
      tamara = document.createElement('div');
      tamara.className = 'rb-bnpl__tamara';
      container.appendChild(tamara);
    }
    renderTabby(tabby, amount, container.dataset.source === 'cart' ? 'cart' : 'product');
    renderTamara(tamara, amount);
  }

  function renderAll(root) {
    (root || document).querySelectorAll('[data-rb-bnpl]').forEach(render);
  }

  function setAmount(selector, cents, scope) {
    (scope || document).querySelectorAll(selector).forEach((c) => {
      c.dataset.amount = String(cents);
      render(c);
    });
  }

  function onVariantChange(event) {
    const variant = event && event.data && event.data.variant;
    if (!variant || variant.price == null) return;
    const sectionId = event.data.sectionId;
    const scope = (sectionId && document.querySelector('[data-section="' + sectionId + '"]')) || document;
    setAmount('[data-rb-bnpl][data-source="product"]', variant.price, scope);
  }

  function onCartUpdate(event) {
    const total = event && event.cartData && event.cartData.total_price;
    if (total != null) {
      setAmount('[data-rb-bnpl][data-source="cart"]', total);
      return;
    }
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
      .then((r) => r.json())
      .then((cart) => setAmount('[data-rb-bnpl][data-source="cart"]', cart.total_price))
      .catch(() => {});
  }

  function init() {
    renderAll();
    // global.js declares these with function/const at top level, so they are
    // reachable as bare names but PUB_SUB_EVENTS is not a window property.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    // Section re-renders (cart drawer, quick add) swap in fresh containers.
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-rb-bnpl]')) render(n);
          else if (n.querySelector && n.querySelector('[data-rb-bnpl]')) renderAll(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
